import { render } from "./Ticket.vue?vue&type=template&id=3edb008a&ts=true"
import script from "./Ticket.vue?vue&type=script&lang=ts"
export * from "./Ticket.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__